import { isUserAdmin } from './groups';

/**
 * Проверка прав доступа к пунктам меню
 */
export function canAccessMenuItem(itemTitle: string, userGroups: number[] | undefined): boolean {
  // Пункты, доступные только администраторам (коды 200-299)
  const adminOnlyItems = ['Пользователи', 'Синхронизация', 'AI'];

  // Если нет информации о группах, доступ запрещен к защищенным пунктам
  if (!userGroups || userGroups.length === 0) {
    return !adminOnlyItems.includes(itemTitle);
  }

  // Проверка доступа к админским пунктам
  if (adminOnlyItems.includes(itemTitle)) {
    // Доступ только для администраторов (коды 200-299)
    // Проверяются все группы пользователя
    return isUserAdmin(userGroups);
  }

  // Все остальные пункты доступны всем
  return true;
}
